<template>
  <div class="wrapper" v-if="data != undefined">
    <Menu />
    <div class="header-area">
      <div class="container-fluid">
        <div class="position-relative row player-career user-profile">
          <div class="mt-5 user-profile-head">
            <div class="user-image">
              <img
                :src="data.avatarUrl"
                alt
                class="rounded-circle mb-3 b-4"
                style="width: 100px; height: 100px"
              />
            </div>
            <h1 class="fs-20 fc-5 mb-3">
              {{ data.first_name }}
              <span class="font-weight-normal">{{ data.last_name }}</span>
            </h1>
            <h2 class="fs-24 fc-1 mb-4">{{ data.checked_in_count }} Maça Katıldı</h2>
          </div>
        </div>
      </div>
    </div>
    <div class="body-area">
      <div class="container-fluid">
        <div class="row">
          <div class="col-12 p-0 text-center mt-19">
            <button
              v-if="$store.getters.isLogged"
              :class="data.is_following ? 'follow' : 'unfollow'"
              @click="toggleFollow"
            >{{ data.is_following ? 'Takipten Çıkar' : 'Takip Et' }}</button>

            <button
              v-if="$store.getters.isLogged == false"
              :class="data.is_following ? 'follow' : 'unfollow'"
              @click="goLogin"
            >Takip İçin Giriş Yap</button>
          </div>

          <div class="item-box w-100" v-if="$store.getters.isLogged">
            <div class="col-12">
              <UserActionsProfile :id="id" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>


<script>
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import Menu from "@/components/Menu";
import axios from "axios";
import UserActionsProfile from "@/components/UserActionsProfile";
export default {
  name: "Profile",
  components: {
    Footer,
    Menu,
    Header,
    UserActionsProfile
  },
  data() {
    return {
      id: this.$route.params.id,
      data: this.$route.params.data
    };
  },
  methods: {
    toggleFollow() {
      if (this.data.is_following) {
        var data = new FormData();
        data.append("user_token", this.$store.state.user.token);
        data.append("following_user_id", this.id);
        axios.post("sosyal/takipten-cikar", data).then(res => {
          if (res.data.status == 200) {
            this.data.is_following = false;
          } else {
            this.$message.error(res.data.data);
          }
        });
      } else {
        var data = new FormData();
        data.append("user_token", this.$store.state.user.token);
        data.append("following_user_id", this.id);
        axios.post("sosyal/takip-et", data).then(res => {
          if (res.data.status == 200) {
            this.data.is_following = true;
          } else {
            this.$message.error(res.data.data);
          }
        });
      }
    },
    goLogin() {
      localStorage.setItem(
        "redir",
        JSON.stringify({
          params: { id: this.$route.params.id, slug: this.$route.params.slug },
          name: "Profile"
        })
      );
      this.$router.push({ name: "Login" });
    }
  },
  beforeMount() {
    if (this.data == undefined) {
      this.$store.state.loading = true;

      var data = new FormData();
      data.append(
        "user_token",
        this.$store.getters.isLogged ? this.$store.state.user.token : ""
      );
      data.append("user_id", this.id);
      axios.post("sosyal/profil", data).then(res => {
        this.$store.state.loading = false;
        if (res.data.status == 401) {
          this.$message.error(res.data.data);
          this.$router.go(-1);
          return;
        }
        this.data = res.data.data;
      });
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/pages/Profile.vue